export default __webpack_public_path__ + "static/media/multiple-option-back.1bda3f19.png";